import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { isUndefined } from 'util';

import { SingleSelectItem } from './single-select-item';

@Component({
  selector: 'nec-single-select',
  templateUrl: './single-select.component.html',
  styleUrls: ['./single-select.component.scss']
})
export class NecSingleSelectComponent implements OnInit, AfterViewInit {

  @Input() items: SingleSelectItem[];

  @Input() selectedItem: SingleSelectItem;

  @Input() describe: string;

  @Input() autoSize?: boolean;

  @Input() limitLength?: number;

  @Output() selectedItemChange = new EventEmitter();

  @Input() checkPass?: boolean = true;

  showMenu: boolean;

  timer: any;

  width: number = 120;

  constructor(
    private el: ElementRef
  ) {
    this.showMenu = false;
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      if (this.autoSize) {
        this.width = this.el.nativeElement.parentElement.offsetWidth;
      }
    });
  }

  ngOnInit() {
    this.describe = this.describe || '';
    if (isUndefined(this.limitLength)) {
      this.limitLength = 6;
    }
  }

  /**
   * é¼ æ ç¦»å¼æ¶è§¦å
   */
  mouseLeaveBox() {
    this.showMenu = false;
    clearInterval(this.timer);
  }

  /**
   * å±å¼ä¸æèå
   */
  buttonClick() {
    this.showMenu = true;
    // TODO: æ²¡æ¾å°ééççå¬æ¹å¼ï¼æç¨å®æ¶å¨ä»£æ¿
    setTimeout(() => {
      this.getBoundingClientRect();
    });
    this.timer = setInterval(() => {
      this.getBoundingClientRect();
    }, 100);
  }

  getBoundingClientRect() {
    const dropdownMenuEle = this.el.nativeElement.querySelector('.drop-down-menu');
    if (!dropdownMenuEle) {
      return;
    }
    const boundingClientRect = this.el.nativeElement.querySelector('.single-select-box').getBoundingClientRect() as DOMRect;
    dropdownMenuEle.style.top = boundingClientRect.y + boundingClientRect.height + 'px';
    dropdownMenuEle.style.left = boundingClientRect.x + 'px';
  }

  /**
   * ç¹å»ä¸æèåé¡¹
   * @param item
   */
  selectItem(item: SingleSelectItem) {
    this.setAllFalse();
    this.showMenu = false;
    clearInterval(this.timer);
    if (!isUndefined(item)) {
      if (isUndefined(this.selectedItem) || item.data !== this.selectedItem.data) {
        item.isSelected = true;
        this.selectedItem = item;
        this.selectedItemChange.emit(this.selectedItem);
      }
    }
  }

  private setAllFalse() {
    this.items.forEach(item => {
      item.isSelected = false;
    });
  }
}
